// extracted by mini-css-extract-plugin
module.exports = {"messagePopup":"_2dDP6","asRounded":"_1UzlO","isExpanded":"_22mJz"};